const toggleMenu = document.querySelectorAll(".toggleMenu"),
    toggleMenuMobile = document.querySelector(".menu-hp-mobile-container"),
    toggleMenuMobileClose = document.querySelector(".icon-close-sg-menu-svg"),
    openFiltersMobile = document.querySelector(".filters-button-toogle"),
    closeFiltersMobile = document.querySelector(".icon-close-sg-filters-svg"),
    toggleSearch = document.querySelectorAll(".toggleSearch"),
    toggleLanguage = document.querySelector(".language-active"),
    toggleRightPanel = document.querySelectorAll(".open-right-panel"),
    showFiltersElem = document.querySelectorAll(".filters-elem-header"),
    scrolltotop = document.querySelector(".scroll-to-top"),
    body = document.body,
    input = document.querySelectorAll('input'),
    docHeight = document.body.offsetHeight,
    buttonbackHistory = document.querySelector(".property-arrow-back"),
    expectedPrice = document.querySelectorAll(".form-input-label-expected"),
    menuLink = document.querySelectorAll(".menu-container nav a"),
    filters = document.querySelectorAll(".page-list-filters"),
    filtersElem = document.querySelectorAll(".filters-elem"),
    galleryExpand = document.querySelectorAll(".gallery_expand");

window.addEventListener("load", (event) => {
    body.classList.add("load");
});

showFiltersElem.forEach((item) => {
    item.addEventListener("click", (event) => {
        if (item.parentNode.classList.contains("active-filters-elem")) {
            closeAllFilters();
        } else {
            closeAllFilters();
            item.parentNode.classList.toggle("active-filters-elem");
        }
    });
});

if (filters) {
    filters.forEach((item) => {
        document.addEventListener('click', function(event) {
            var isClickInsideElement = item.contains(event.target);
            if (!isClickInsideElement) {
                filtersElem.forEach((item) => {
                    item.classList.remove("active-filters-elem");
                });
            }
        });
    });
}

input.forEach((item) => {
    item.addEventListener('input', evt => {
        const value = item.value.trim()
        if (value) {
            item.dataset.state = 'valid'
        } else {
            item.dataset.state = 'invalid'
        }
    });
});

if (menuLink) {
    menuLink.forEach((item) => {
        const mainMenu = document.getElementById('mainMenu');

        item.addEventListener("click", (event) => {
            event.preventDefault();
            mainMenu.classList.add("menu-fadeout");
            setTimeout(function() {
                mainMenu.classList.toggle("overlay-shown");
                document.body.classList.toggle("overlay-opened");
                mainMenu.classList.remove("menu-fadeout");
            }, 600);
            const link = item.href;
            window.location.href = link;
        });
    });
}

if (buttonbackHistory) {
    buttonbackHistory.addEventListener(
        "click",
        (e) => {
            e.preventDefault();
            window.history.back();
        },
        false
    );
}

expectedPrice.forEach((item) => {
    item.addEventListener("click", (event) => {
        item.classList.remove("active")
    });
});

if (toggleLanguage) {
    toggleLanguage.addEventListener(
        "click",
        (e) => {
            e.preventDefault();
            togglePanel("active-language");
        },
        false
    );
}

if (openFiltersMobile) {
    openFiltersMobile.addEventListener(
        "click",
        (e) => {
            e.preventDefault();
            togglePanel("active-mobile-filters");
        },
        false
    );
}

if (closeFiltersMobile) {
    closeFiltersMobile.addEventListener(
        "click",
        (e) => {
            e.preventDefault();
            togglePanel("active-mobile-filters");
        },
        false
    );
}

if (scrolltotop) {
    scrolltotop.addEventListener(
        "click",
        (e) => {
            window.scrollTo(0, 0);
        },
        false
    );
}

toggleMenu.forEach((item) => {
    item.addEventListener("click", (event) => {
        togglePanel("active-menu");
    });
});

toggleSearch.forEach((item) => {
    item.addEventListener("click", (event) => {
        togglePanel("active-search");
    });
});

toggleRightPanel.forEach((item) => {
    item.addEventListener("click", (event) => {
        togglePanel("active-right-panel");
    });
});

if (toggleMenuMobile) {
    toggleMenuMobile.addEventListener("click", function () {
        body.classList.toggle("active-sg-menu-mobile");
    });

    toggleMenuMobileClose.addEventListener("click", function () {
        body.classList.toggle("active-sg-menu-mobile");
    });
};

if (galleryExpand) {
galleryExpand.forEach((item) => {
    item.addEventListener("click", (event) => {
        togglePanel("gallery_full");
    });
});
};

function togglePanel(classitem) {
    body.classList.toggle(classitem);
}

function closeAllFilters() {
    showFiltersElem.forEach(el => el.parentNode.classList.remove("active-filters-elem"));
}

var x, i, j, l, ll, selElmnt, a, b, c;
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 0; j < ll; j++) {
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function(e) {
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    s.dispatchEvent(new CustomEvent('customSelectChange')); // send custom event
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    for (k = 0; k < yl; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
    });
}
function closeAllSelect(elmnt) {
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}
document.addEventListener("click", closeAllSelect);


const leftFavourite= document.querySelector(".add-to-favourites-left-side")

function toggleLeftFavourites () {
    const y = window.scrollY;
    if (y >= 800 && y < docHeight - 900) {
        leftFavourite.classList.add("active");
    } else {
        leftFavourite.classList.remove("active");
    }
};

if (leftFavourite) {
    window.addEventListener("scroll", toggleLeftFavourites);
}

function disapearsElem (elem) {
    const e = elem;
    const y = window.scrollY;
    if (y > docHeight - 700) {
        e.classList.add("hidden");
    } else {
        e.classList.remove("hidden");
    }
};

const dynamicMenu= document.querySelector("#dynamic-menu");
const dynamicMenuTitle= document.querySelector(".page-header__title");
const policyHeader= document.querySelector(".policy-header-right-container");

if (dynamicMenu) {
    window.addEventListener("scroll", function(){ disapearsElem(dynamicMenu);});
    window.addEventListener("scroll", function(){ disapearsElem(dynamicMenuTitle);});
}

if (policyHeader) {
    window.addEventListener("scroll", function(){ disapearsElem(policyHeader);});
}


const pathMap = document.querySelectorAll(".search-map .b"),
    inputDistrict = document.querySelectorAll(".filters-elem-district input");

pathMap.forEach((item) => {
    item.addEventListener("click", (event) => {
        const checkboxDistrict = document.querySelector('input[data-district="'+item.dataset.value+'"]');
        if (checkboxDistrict) {
            checkboxDistrict.click();
        }
    });
});

inputDistrict.forEach((item) => {
    item.addEventListener("click", (event) => {
        const mapDistrict = document.querySelector('.search-map .b[data-value="'+item.dataset.district+'"]');
        mapDistrict.classList.toggle("active");
    });
});
